<h2>Materials</h2>
<p>Below is a list of all materials.</p>
@if (data()) {
  <angular2-smart-table [settings]="settings" [source]="source" />
} @else {
  <app-loader />
}